module.exports = __webpack_public_path__ + "img/house-fill.ebf192bb.svg";